<div class="flex flex-col">
  <div class="w-[30rem] m-auto max-w-full">
    <p-timeline
      [value]="steps"
      layout="horizontal"
      align="top"
      *ngIf="mode == 'register'"
    >
      <ng-template pTemplate="content" let-item>
        <div
          class="inline-block w-max text-center -translate-x-1/2 ml-2 mt-2"
          [class]="
            currentStep > steps.indexOf(item) + 1
              ? 'past'
              : currentStep == steps.indexOf(item) + 1
              ? 'current'
              : 'future'
          "
        >
          {{ item.label | translate }}
        </div>
      </ng-template>
      <ng-template pTemplate="marker" let-item>
        <div
          class="p-timeline-event-marker"
          [class]="
            currentStep > steps.indexOf(item) + 1
              ? 'past'
              : currentStep == steps.indexOf(item) + 1
              ? 'current'
              : 'future'
          "
        >
          <div
            class="text-green-900 translate-y-[-0.4rem] text-xl leading-[1rem]"
            *ngIf="currentStep > steps.indexOf(item) + 1"
          >
            ✓
          </div>
        </div>
      </ng-template>
    </p-timeline>
  </div>
  <div
    class="overflow-x-clip"
    [ngClass]="
      mode == 'register' ? 'overflow-y-auto' : ''
    "
  >
    <div
      class="relative overflow-x-hidden"
      [ngClass]="
        mode == 'register' ? 'h-[calc(90vh-12rem)] overflow-y-auto' : ''
      "
    >
      <div
        *ngIf="isTandC"
        class="switch-page w-full max-w-3xl md:mt-0 xl:p-0 mr-auto"
        [class]="
          [currentStep == 1 ? 'active' : currentStep > 1 ? 'past' : 'future',
          (mode == 'register' ? '' : 'hidden')
          ]
        "
      >
        <div class="sm:px-4" [class]="pv ? '' : 'p-0 sm:p-0 sm:px-0'">
          <div class="col-span-12 md:col-span-10 grid grid-cols-12">
            <div
              class="col-span-12 md:pr-2 md:pb-0 flex flex-row space-x-2"
            >
              <!-- <fa-icon class="text-green-600 cursor-pointer" [icon]="faBack" (click)="onRegisterStep2Back()"></fa-icon> -->
              <label
                for="email"
                class="block mb-2 font-medium text-gray-900 dark:text-white"
                ><span
                  class="text-xl font-medium text-green-900 dark:text-white"
                  >{{ 'Personal Information Collection Statement' | translate }}</span
                ></label
              >
            </div>
          </div>

          <div class="text-gray-600">
            <div
              class="h-[calc(90vh-20rem)] md:h-[calc(90vh-19rem)] overflow-y-scroll border p-2"
              (scroll)="onTandc1Scroll($event)"
            >
              <ng-container *ngIf="translate.currentLang == 'zh-Hant'">
                <p class="paragraph">1. 個人資料的收集</p>
                <p class="paragraph ml-6">a. 你向建造業議會、其關聯及／或附屬公司，包括但不限於香港建造學院、建造業零碳天地、建造業輸入勞工宿舍有限公司（統稱「議會」）提供的資料，包括《個人資料（私隱）條例》（第 486 章）中定義的任何個人資料，只會用於與議會活動相關之目的。具體活動及所需個人資料將在申請表中詳細列明。</p>
                <p class="paragraph ml-6">b. 你是否向議會提供個人資料純屬自願性質。然而，如果你提供資料之目的是為了作出查詢，你便須向議會提供申請表上所指明的資料。否則，議會可能無法處理或考慮你的申請。如果你未滿十八歲，在向議會提供你的個人資料前，應先徵詢你的父母或監護人。</p>
                <p class="paragraph ml-6">c. 你有權查閱你的個人資料和更正當中的錯誤。如需要作出此要求，請致函議會的助理總監–註冊事務提出 (查閱要求)以提交書面請求，地址爲九龍觀塘駿業街 56 號中海日升中心 38 樓建造業議會。如你對我們的負責人及有關做法有任何查詢，請致函上述地址聯絡助理總監 – 註冊事務或電郵至 enquiry@cic.hk。如需要更多關於議會在私隱及保障個人資料政策的資料，請參閱我們的<a class="font-bold underline" href="https://www.cic.hk/chi/main/privacy_policy_statement/" target="_blank">私隱政策</a>。</p>
                <br />
                <p class="paragraph">2. 收集的目的</p>
                <p class="paragraph ml-5">你的個人資料將會被保密，並可能用於以下用途：</p>
                <p class="paragraph ml-6">a. 為使你得知最新的議會活動及行業發展情況，議會將使用你的個人資料，包括姓名、電話號碼、通訊地址及電郵地址，向你提供有關訓練課程、測試、註冊、活動項目、議會工作，以及建造業其他方面的最新資訊；</p>
                <p class="paragraph ml-6">b. 方便與你的通訊；</p>
                <p class="paragraph ml-6">c. 履行和行使議會根據相關條例、規則和附屬法規授予的職能和權力，包括但不限於《建造業議會條例》（第 587 章）及《建造業工人註冊條例》（第 583 章）；</p>
                <p class="paragraph ml-6">d. 確立、行使或維護議會的法律權利及遵從議會的法律和規管責任（包括打擊洗錢責任、遵從法院或監管機構的命令等）；</p>
                <p class="paragraph ml-6">e. 管理進出議會處所和保安目的；</p>
                <p class="paragraph ml-6">f. 防止和應對實際或潛在的安全威脅、詐騙或非法活動；</p>
                <p class="paragraph ml-6">g. 處理投訴或查詢；</p>
                <p class="paragraph ml-6">h. 進行分析、研究和意見調查；</p>
                <p class="paragraph ml-6">i. 用於議會內部進行分析，以協助了解行業趨勢及制訂有關建造業發展的策略；</p>
                <p class="paragraph ml-6">j. 進行審計及合規審查，以確保遵守適用的議會政策、程序、規例及法律；</p>
                <p class="paragraph ml-6">k. 與議會活動進行相關或附帶的其他目的；及</p>
                <p class="paragraph ml-6">l. 你不時同意的任何其他目的。</p>
                <br />
                <p class="paragraph">3. 個人資料的披露及轉移</p>
                <p class="paragraph ml-6">a. 因應第 2 段所述目的，議會可能披露或轉移你的個人資料予第三方，包括但不限於以下：</p>
                <p class="paragraph ml-12">i. 如 1 (a) 節所述，任何或所有議會關聯及/或附屬公司；</p>
                <p class="paragraph ml-12">ii. 任何代表議會營運或維持會員資格、活動註冊、導賞預約、研究及／或分析，或代表議會進行後端服務、行政服務、驗證服務、雲端服務或資訊科技服務，或向議會提供所需支援或服務（包括保險、銀行或議會使用的任何第三方支付網關服務）以使議會提供服務的第三方服務提供商、承包商或分包商，及代表議會履行合約規範責任之實體；或</p>
                <p class="paragraph ml-12">iii. 議會的專業顧問，包括但不限於律師、會計師和審計師；</p>
                <p class="paragraph ml-6">b. 按照任何適用於議會的法律規定或規管性質規定或法院命令，議會可能披露及轉移你的個人資料。</p>
                <br />
                <p class="paragraph">最後更新日期: 2025 年 9 月 25 日</p>
              </ng-container>
              <ng-container *ngIf="translate.currentLang == 'zh-Hans'">
                <p class="paragraph">1. 个人资料的收集</p>
                <p class="paragraph ml-6">a. 你向建造业议会、其关联及／或附属公司，包括但不限于香港建造学院、建造业零碳天地、建造业输入劳工宿舍有限公司（统称「议会」）提供的资料，包括《个人资料(私隐)条例》（第486章）中定义的任何个人资料，只会用于与议会活动相关之目的。具体活动及所需个人资料将在申请表中详细列明。</p>
                <p class="paragraph ml-6">b. 你是否向议会提供个人资料纯属自愿性质。然而，如果你提供资料之目的是为了作出查询，你便须向议会提供申请表上所指明的资料。否则，议会可能无法处理或考虑你的申请。如果你未满十八岁，在向议会提供你的个人资料前，应先徵询你的父母或监护人。</p>
                <p class="paragraph ml-6">c. 你有权查阅你的个人资料和更正当中的错误。如需要作出此要求，请致函议会的助理总监–注册事务提出 (查阅要求) 以提交书面请求，地址为九龙观塘骏业街56号中海日升中心38楼建造业议会。如你对我们的负责人及有关做法有任何查询，请致函上述地址联络助理总监 – 注册事务或电邮至 enquiry@cic.hk。如需要更多关于议会在私隐及保障个人资料政策的资料，请参阅我们的<a class="font-bold underline" href="https://www.cic.hk/sch/main/privacy_policy_statement/" target="_blank">私隐政策</a>。</p>
                <br />
                <p class="paragraph">2. 收集的目的</p>
                <p class="paragraph">你的个人资料将会被保密，并可能用于以下用途：</p>
                <p class="paragraph ml-6">a. 为使你得知最新的议会活动及行业发展情况，议会将使用你的个人资料，包括姓名、电话号码、通讯地址及电邮地址，向你提供有关训练课程、测试、註册、活动项目、议会工作，以及建造业其他方面的最新资讯；</p>
                <p class="paragraph ml-6">b. 方便与你的通讯；</p>
                <p class="paragraph ml-6">c. 履行和行使议会根据相关条例、规则和附属法规授予的职能和权力，包括但不限于《建造业议会条例》（第587章）及《建造业工人注册条例》（第583章）；</p>
                <p class="paragraph ml-6">d. 确立、行使或维护议会的法律权利及遵从议会的法律和规管责任（包括打击洗钱责任、遵从法院或监管机构的命令等）；</p>
                <p class="paragraph ml-6">e. 管理进出议会处所和保安目的；</p>
                <p class="paragraph ml-6">f. 防止和应对实际或潜在的安全威胁、诈骗或非法活动；</p>
                <p class="paragraph ml-6">g. 处理投诉或查询；</p>
                <p class="paragraph ml-6">h. 进行分析、研究和意见调查；</p>
                <p class="paragraph ml-6">i. 用于议会内部进行分析，以协助了解行业趋势及制订有关建造业发展的策略；</p>
                <p class="paragraph ml-6">j. 进行审计及合规审查，以确保遵守适用的议会政策、程序、规例及法律；</p>
                <p class="paragraph ml-6">k. 与议会活动进行相关或附带的其他目的；及</p>
                <p class="paragraph ml-6">l. 你不时同意的任何其他目的。</p>
                <br />
                <p class="paragraph">3. 个人资料的披露及转移</p>
                <p class="paragraph ml-6">a. 因应第2段所述目的，议会可能披露或转移你的个人资料予第三方，包括但不限于以下：</p>
                <p class="paragraph ml-12">i. 如1 (a) 节所述，任何或所有议会关联及/或附属公司；</p>
                <p class="paragraph ml-12">ii. 任何代表议会营运或维持会员资格、活动注册、导赏预约、研究及／或分析，或代表议会进行后端服务、行政服务、验证服务、云端服务或资讯科技服务，或向议会提供所需支援或服务（包括保险、银行或议会使用的任何第三方支付网关服务）以使议会提供服务的第三方服务提供商、承包商或分包商，及代表议会履行合约规范责任之实体；或</p>
                <p class="paragraph ml-12">iii. 议会的专业顾问，包括但不限于律师、会计师和审计师；</p>
                <p class="paragraph ml-6">b. 按照任何适用于议会的法律规定或规管性质规定或法院命令，议会可能披露及转移你的个人资料。</p>
                <br />
                <p class="paragraph">最后更新日期: 2025年9月25日</p>
              </ng-container>
              <ng-container *ngIf="translate.currentLang == 'en'">
                <p class="paragraph">1. Collection of Personal Data</p>
                <p class="paragraph ml-6">a. The information you provide to the Construction Industry Council, its affiliates, and / or its subsidiaries, including, but not limited to, the Hong Kong Institute of Construction and Zero Carbon Building, Construction Sector Imported Labour Quarters Limited (collectively, the“CIC”), including any personal data as defined in the Personal Data (Privacy) Ordinance (Cap.486), will be used solely for purposes related to the activities of the CIC. The activity and the required personal data are detailed in the application form.</p>
                <p class="paragraph ml-6">b. Whether or not you provide your personal data to the CIC is voluntary. However, where you are providing information for the purpose of an application, it is necessary that you supply the CIC with complete information as specified on the application form. Otherwise, the CIC may be unable to process or consider your application. If you are under the age of 18, you should consult your parent or guardian before providing any personal data to us.</p>
                <p class="paragraph ml-6">c. You are entitled to request access to and correction of any errors in your personal data. If you wish to do so, please write to Assistant Director – Registration Services (Data Access Request), Construction Industry Council, 38/F COS Centre, 56 Tsun Yip Street, Kwun Tong, Kowloon. Should you have any enquiries about our PICS and related practices, please contact Assistant Director – Registration Services at the above address or via enquiry@cic.hk. For more information about the CIC’s policies on privacy and personal data protection, you can access our <a class="font-bold underline" href="https://www.cic.hk/eng/main/privacy_policy_statement/" target="_blank">Privacy Policy Statement</a>.</p>
                <br />
                <p class="paragraph">2. Purposes of Collection</p>
                <p class="paragraph">Your personal data will be kept confidential and may be used by the CIC for the following purposes:</p>
                <p class="paragraph ml-6">a. To keep you informed of the latest activities of the Council or the Institute, as well as developments within the industry, the Council or the Institute will use your personal data — including your name, telephone number, mailing address, and email address — to provide you with information about training courses, assessments, registration, events, Council or Institute work, and other updates related to the construction industry.</p>
                <p class="paragraph ml-6">b. Facilitating communication with you;</p>
                <p class="paragraph ml-6">c. Performing and exercising functions and powers of the CIC under relevant legislation, rules and sub-legislation, including but not limited to the Construction Industry Council Ordinance (Cap.  587) and Construction Workers Registration Ordinance (Cap. 583);</p>
                <p class="paragraph ml-6">d. Establishing, exercising and defending the CIC’s legal rights, and complying with the CIC’s legal and regulatory obligations (including anti-money laundering obligations, complying with orders by courts or regulators, etc.);</p>
                <p class="paragraph ml-6">e. Managing access to the CIC’s premises and for security purposes;</p>
                <p class="paragraph ml-6">f. Preventing and responding to actual or potential security threats, fraud or illegal activities;</p>
                <p class="paragraph ml-6">g. Handling complaints or enquiries;</p>
                <p class="paragraph ml-6">h. Performing analysis and conducting research and surveys;</p>
                <p class="paragraph ml-6">i. For internal analysis by the CIC to support understanding of industry trends and the formulation of strategies for the development of the construction industry;</p>
                <p class="paragraph ml-6">j. Performing audits and compliance reviews to ensure compliance with the applicable CIC’s policies and procedures, regulations and law;</p>
                <p class="paragraph ml-6">k. Other purposes related or incidental to the conduct of the CIC’s activities; and</p>
                <p class="paragraph ml-6">l. Any other purposes that you may consent to from time to time.</p>
                <br />
                <p class="paragraph">3. Disclosure and Transfer of Personal Data</p>
                <p class="paragraph ml-6">a. The CIC may disclose or transfer your personal data for the purposes as stated in paragraph 2 to third parties, including but not limited to the following:</p>
                <p class="paragraph ml-12">i. Any or all of the CIC’s affiliates and/or subsidiaries listed in 1(a) above;</p>
                <p class="paragraph ml-12">ii. Any third party service providers, contractors/sub-contractors that, on behalf of the CIC, operate or maintain membership, event registration, tour booking, researches and/or analysis, or carry out back-end services, administrative services, verification services, cloud services or information technology services, or provide necessary support or services to the CIC to enable us to provide our services, including any insurance, banking or third party payment gateways services used by the CIC, and any other entities that discharge contractual obligations on our behalf; or</p>
                <p class="paragraph ml-12">iii. Any of the CIC’s professional advisors, including but not limited to lawyers, accountants and auditors;</p>
                <p class="paragraph ml-6">b. We may disclose and transfer your personal data in accordance with any legal or regulatory requirements or any court order applicable to the CIC.</p>
                <br />
                <p class="paragraph">Last Updated Date: 25th September, 2025</p>
              </ng-container>
            </div>
            <div
              *ngIf="isTandc1Error && !isTandc1Read"
              class="text-red-600 col-span-10 mt-2"
            >
              {{
                'Please read the Personal Information Agreement to the end.'
                  | translate
              }}
            </div>
            <!-- <div class="mt-2">
            <input type="checkbox" name="tandc1" (change)="onTandc1Change($event)" class="rounded checked:bg-green-600 checked:hover:bg-green-600 checked:active:bg-green-600 checked:focus:bg-green-600 focus:outline-none focus:ring-green-600" /><span class="text-red-500 ml-1">*</span>
            <span class="text-xs text-gray-600 ml-2">{{ 'I have read and understand the Personal Information Agreement' | translate }}</span>
          </div>
          <div
            *ngIf="!isTandc1 && isSubmitted"
            class="text-red-600 col-span-10 text-xs mt-1"
            >
            {{ 'Please agree with the Personal Information Agreement.' | translate }}
          </div> -->
            <div class="mt-6 flex flex-row justify-center md:justify-start">
              <div class="flex-grow"></div>
              <button
                class="flex flex-row justify-center w-40 text-white bg-notus-primary-600 hover:bg-notus-primary-700 focus:outline-none focus:ring-notus-primary-300 font-medium rounded-3xl text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 items-center"
                *ngIf="!isLoading && !disableUserInfo"
                (click)="onRegisterStep2Confirm()"
              >
                {{ 'Agree' | translate }}
              </button>
              <button
                type="submit"
                disabled
                class="flex flex-row justify-center w-40 text-white bg-gray-300 focus:outline-none focus:ring-notus-primary-300 font-medium rounded-3xl text-sm px-5 py-2.5 text-center dark:bg-white"
                *ngIf="isLoading"
              >
                <flowbite-loading size="1.25rem"></flowbite-loading>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="switch-page w-full max-w-3xl md:mt-0 xl:p-0 mr-auto"
        [class]="
          (currentStep == 2 ? 'active' : currentStep > 2 ? 'past' : 'future') +
          ' ' +
          (mode == 'register' ? 'h-[calc(90vh-12rem)] overflow-y-auto' : '')
        "
      >
        <div
          class="md:space-y-6 px-1 sm:px-4"
          [class]="pv ? '' : 'p-0 sm:p-0 sm:px-0'"
          action="#"
          [formGroup]="form"
        >
          <div *ngIf="iamsmartInfo">
            <img src="/assets/images/iamsmart-icon-green.png" class="h-6 ml-2 inline-block" /> {{ 'iamsmart profile info' | translate }}
          </div>

          <!-- Personal Title -->
          <div class="grid grid-cols-12">
            <label
              for="email"
              class="col-span-12 md:col-span-2 block mb-2 text-base font-medium text-green-900 dark:text-white pr-1"
              >{{ 'Personal Title' | translate }}
              <span class="text-red-500">*</span></label
            >
            <div class="col-span-12 md:col-span-10 mb-4">
              <div class="flex flex-row">
                <div
                  class="mr-4 cursor-pointer"
                  (click)="
                    disableUserInfo
                      ? null
                      : form.controls.personalTitle.setValue('Mr.')
                  "
                >
                  <input
                    type="radio"
                    name="personalTitle"
                    formControlName="personalTitle"
                    class="rounded-full checked:bg-green-600 checked:hover:bg-green-600 checked:active:bg-green-600 checked:focus:bg-green-600 focus:outline-none focus:ring-green-600"
                    value="Mr."
                    [attr.disabled]="disableUserInfo ? '' : null"
                  />
                  <span class="text-sm text-gray-600 ml-2">{{
                    'Mr.' | translate
                  }}</span>
                </div>
                <div
                  class="mr-4 cursor-pointer"
                  (click)="
                    disableUserInfo
                      ? null
                      : form.controls.personalTitle.setValue('Ms.')
                  "
                >
                  <input
                    type="radio"
                    name="personalTitle"
                    formControlName="personalTitle"
                    class="rounded-full checked:bg-green-600 checked:hover:bg-green-600 checked:active:bg-green-600 checked:focus:bg-green-600 focus:outline-none focus:ring-green-600"
                    value="Ms."
                    [attr.disabled]="disableUserInfo ? '' : null"
                  />
                  <span class="text-sm text-gray-600 ml-2">{{
                    'Ms.' | translate
                  }}</span>
                </div>
                <div
                  class="mr-4 cursor-pointer"
                  (click)="
                    disableUserInfo
                      ? null
                      : form.controls.personalTitle.setValue('Mrs.')
                  "
                >
                  <input
                    type="radio"
                    name="personalTitle"
                    formControlName="personalTitle"
                    class="rounded-full checked:bg-green-600 checked:hover:bg-green-600 checked:active:bg-green-600 checked:focus:bg-green-600 focus:outline-none focus:ring-green-600"
                    value="Mrs."
                    [attr.disabled]="disableUserInfo ? '' : null"
                  />
                  <span class="text-sm text-gray-600 ml-2">{{
                    'Mrs.' | translate
                  }}</span>
                </div>
              </div>
              <div
                *ngIf="
                  form.controls.personalTitle.invalid &&
                  (form.controls.personalTitle.dirty ||
                    form.controls.personalTitle.touched)
                "
                class="text-red-600 col-span-10 text-xs mt-1"
              >
                <div *ngIf="form.controls.personalTitle.errors?.['required']">
                  {{ 'Personal title is required.' | translate }}
                </div>
              </div>
            </div>
          </div>
          <!-- Name in English -->
          <div class="grid grid-cols-12">
            <div class="col-span-12 md:col-span-2">
              <label
                for="email"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white pr-1 my-2"
                ><span
                  class="text-base font-medium text-green-900 dark:text-white"
                  >{{ 'Name in English' | translate }}</span
                >
                <span class="text-red-500">*</span></label
              >
            </div>
            <div class="col-span-12 md:col-span-10 grid grid-cols-12">
              <div class="col-span-12 pb-2 md:col-span-6 md:pr-2 md:pb-0 mb-2">
                <div class="flex flex-row items-center">
                  <span class="p-float-label relative flex-grow">
                    <input
                      pInputText
                      name="lastName"
                      id="lastName"
                      class="border border-gray-300 text-gray-900 text-sm rounded-3xl focus:ring-green-600 focus:border-green-600 focus:outline-green-600 block w-full p-2.5 px-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder=""
                      required=""
                      formControlName="lastName"
                      [attr.disabled]="disableUserInfo || isSurnameFromIamSmart() ? '' : null"
                    />

                    <label for="lastName" class="">{{
                      'Surname in English' | translate
                    }}</label>
                  </span>

                  <img src="/assets/images/iamsmart-icon-green.png" class="h-8 ml-2" *ngIf="isSurnameFromIamSmart()" />
                </div>

                <div
                  *ngIf="
                    form.controls.lastName.invalid &&
                    (form.controls.lastName.dirty ||
                      form.controls.lastName.touched)
                  "
                  class="text-red-600 col-span-10 text-xs mt-1"
                >
                  <div *ngIf="form.controls.lastName.errors?.['required']">
                    {{ 'Surname is required.' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-span-12 pb-2 md:col-span-6 md:pr-2 md:pb-0 mb-4">
                <div class="flex flex-row items-center">
                  <span class="p-float-label relative flex-grow">
                    <input
                      pInputText
                      name="firstName"
                      id="firstName"
                      class="border border-gray-300 text-gray-900 text-sm rounded-3xl focus:ring-green-600 focus:border-green-600 focus:outline-green-600 block w-full p-2.5 px-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required=""
                      formControlName="firstName"
                      [attr.disabled]="disableUserInfo || isGivenNameFromIamSmart() ? '' : null"
                    />
                    <label for="lastName" class="">{{
                      'Other names in English' | translate
                    }}</label>
                  </span>

                  <img src="/assets/images/iamsmart-icon-green.png" class="h-8 ml-2" *ngIf="isGivenNameFromIamSmart()" />
                </div>

                <div
                  *ngIf="
                    form.controls.firstName.invalid &&
                    (form.controls.firstName.dirty ||
                      form.controls.firstName.touched)
                  "
                  class="text-red-600 col-span-10 text-xs mt-1"
                >
                  <div *ngIf="form.controls.firstName.errors?.['required']">
                    {{ 'Other names is required.' | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Name in Chinese -->
          <div class="grid grid-cols-12">
            <div class="col-span-12 md:col-span-2">
              <label
                for="lastName"
                class="mb-2 text-sm font-medium text-gray-500 dark:text-white hidden md:invisible"
                >{{ 'Surname in Chinese' | translate }}</label
              >
              <label
                for="email"
                class="col-span-2 block mb-2 text-sm font-medium text-gray-900 dark:text-white my-2"
                ><span
                  class="text-base font-medium text-green-900 dark:text-white"
                  >{{ 'Name in Chinese' | translate }}</span
                ></label
              >
            </div>
            <div class="col-span-12 md:col-span-10 grid grid-cols-12">
              <div class="col-span-12 pb-2 md:col-span-6 md:pr-2 md:pb-0 mb-2">
                <div class="flex flex-row items-center">
                  <span class="p-float-label relative flex-grow">
                    <input
                      pInputText
                      name="lastNameZh"
                      id="lastNameZh"
                      class="border border-gray-300 text-gray-900 text-sm rounded-3xl focus:ring-green-600 focus:border-green-600 focus:outline-green-600 block w-full p-2.5 px-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder=""
                      formControlName="lastNameZh"
                      [attr.disabled]="disableUserInfo ? '' : null"
                    />
                    <label for="lastName" class="">{{
                      'Surname in Chinese' | translate
                    }}</label>
                  </span>

                  <img src="/assets/images/iamsmart-icon-green.png" class="h-8 ml-2" *ngIf="isCSurnameFromIamSmart()" />
                </div>
              </div>
              <div class="col-span-12 pb-2 md:col-span-6 md:pr-2 md:pb-0 mb-4">
                <div class="flex flex-row items-center">
                  <span class="p-float-label relative flex-grow">
                    <input
                      pInputText
                      name="firstNameZh"
                      id="firstNameZh"
                      class="border border-gray-300 text-gray-900 text-sm rounded-3xl focus:ring-green-600 focus:border-green-600 focus:outline-green-600 block w-full p-2.5 px-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder=""
                      formControlName="firstNameZh"
                      [attr.disabled]="disableUserInfo ? '' : null"
                    />
                    <label for="lastName" class="">{{
                      'Other names in Chinese' | translate
                    }}</label>
                  </span>

                  <img src="/assets/images/iamsmart-icon-green.png" class="h-8 ml-2" *ngIf="isCGivenNameFromIamSmart()" />
                </div>
              </div>
            </div>
          </div>
          <!-- Contact -->
          <div class="relative rounded-3xl border border-gray-300 p-4">
            <label
              class="absolute block bg-white px-2 -ml-2 my-0 text-sm text-gray-900 dark:text-white font-medium transform -translate-y-1/2 top-0 z-10 origin-[0]"
              ><span
                class="text-base font-medium text-green-900 dark:text-white"
                >{{ 'Contact' | translate }}</span
              >
              <span class="text-red-500">*</span></label
            >
            <div class="grid grid-cols-12">
              <div class="col-span-12 my-2 md:grid md:grid-cols-12 my-0">
                <label
                  for="phone"
                  class="col-span-2 block mb-2 text-sm font-medium text-gray-900 dark:text-white pr-1 my-2"
                  ><span
                    class="text-base font-medium text-green-900 dark:text-white"
                    >{{ 'Phone Number' | translate }}</span
                  >
                </label>
                <div
                  *ngIf="
                    mode == 'profile';
                    then updateSms2fa;
                    else verifySms2fa
                  "
                ></div>

                <ng-template #updateSms2fa>
                  <ciciam-country-dropdown
                    formControlName="mobilePhone"
                    [enableCountry]="false"
                    [disabled]="false"
                    (formSubmitted)="gotoSecurityPage()"
                    class="col-span-10"
                  >
                    <ng-template #submitButton>
                      <fa-icon [icon]="faEdit"></fa-icon>
                    </ng-template>
                  </ciciam-country-dropdown>
                </ng-template>

                <ng-template #verifySms2fa>
                  <ciciam-country-dropdown
                    formControlName="mobilePhone"
                    [enableCountry]="true"
                    [disabled]="!shouldEnableVerifyPhoneButton"
                    errorMessage="{{ phoneErrorMessage ?? '' | translate }}"
                    [isSubmitting]="isPhoneVerifyLoading"
                    (formSubmitted)="on2faClick('sms')"
                    class="col-span-10"
                  >
                    <ng-template #dropdownMenuItem let-country="country">
                      <span class="inline-flex items-center">
                        {{ country?.idd ?? '' }}
                        {{ country?.name ?? '' | translate }}
                      </span>
                    </ng-template>

                    <ng-template #submitButton *ngIf="!isPhoneVerified">
                      {{ 'Request OTP' | translate }}
                    </ng-template>

                    <ng-template #verifiedStatus *ngIf="isPhoneVerified">
                      <fa-icon
                        class="text-notus-primary-600"
                        size="lg"
                        [icon]="faCheckCircle"
                      ></fa-icon>
                    </ng-template>
                  </ciciam-country-dropdown>
                </ng-template>
              </div>

              <div class="col-span-12 my-2 md:grid md:grid-cols-12 my-0">
                <label
                  for="email"
                  class="col-span-2 block mb-2 text-sm font-medium text-gray-900 dark:text-white pr-1 my-2"
                  ><span
                    class="text-base font-medium text-green-900 dark:text-white"
                    >{{ 'Email Address' | translate }}</span
                  >
                </label>
                <div
                  class="col-span-10 flex flex-row flex-wrap md:flex-nowrap h-10 border border-gray-300 text-gray-900 text-sm rounded-full has-[:focus]:ring-primary-600 has-[:focus]:border-primary-600 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:has-[:focus]:ring-blue-500 dark:has-[:focus]:border-blue-500 mb-6 md:mb-0"
                >
                  <!-- <span class="p-float-label relative">
                    <input
                      pInputText
                      type="email"
                      name="email"
                      id="email"
                      class="border border-gray-300 text-gray-900 text-sm rounded-3xl focus:ring-green-600 focus:border-green-600 focus:outline-green-600 block w-full p-2.5 px-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 focus:outline-0"
                      placeholder=""
                      formControlName="email"
                      autocomplete="off"
                    />
                    <label for="lastName" class="">{{
                      'Email Address' | translate
                    }}</label>
                  </span> -->

                  <input
                    type="email"
                    name="email"
                    id="email"
                    class="flex-grow px-2.5 border-none focus:outline-none focus:ring-0 bg-transparent w-full md:w-auto"
                    placeholder="{{ 'Email Address' | translate }}"
                    formControlName="email"
                    autocomplete="off"
                  />

                  <div
                    *ngIf="
                      mode == 'profile';
                      then updateEmail2fa;
                      else verifyEmail2fa
                    "
                  ></div>

                  <ng-template #updateEmail2fa>
                    <button
                      class="flex justify-around items-center z-10 px-4 py-2.5 text-sm text-white focus:outline-none font-medium rounded-full text-sm px-0 py-2.5 text-center mr-0 md:ml-0 w-full md:w-auto"
                      (click)="gotoSecurityPage()"
                      [class]="enabledButtonClasses"
                    >
                      <fa-icon [icon]="faEdit"></fa-icon>
                    </button>
                  </ng-template>
                  <ng-template #verifyEmail2fa>
                    <div
                      class="justify-around items-center px-4 text-white focus:outline-none font-medium rounded-full text-sm py-2.5 text-center mr-0 md:ml-0 basis-full md:basis-auto"
                      [class]="verifyEmailButtonClasses"
                    >
                      <ng-container *ngIf="!isEmailVerifyLoading">
                        <ng-container *ngIf="!isEmailVerified">
                          <button
                            type="submit"
                            (click)="on2faClick('email')"
                            [disabled]="!shouldEnableVerifyEmailButton"
                          >
                            {{ 'Request OTP' | translate }}
                          </button>
                        </ng-container>

                        <ng-container *ngIf="isEmailVerified">
                          <fa-icon
                            class="text-notus-primary-600"
                            size="lg"
                            [icon]="faCheckCircle"
                          ></fa-icon>
                        </ng-container>
                      </ng-container>

                      <ng-container *ngIf="isEmailVerifyLoading">
                        <flowbite-loading size="1.25rem"></flowbite-loading>
                      </ng-container>
                    </div>
                  </ng-template>
                </div>
              </div>

              <div
                *ngIf="form.controls.email.invalid"
                class="text-red-600 col-span-12 md:col-span-10 text-xs mt-[2.5rem] md:mt-1"
              >
                <div *ngIf="form.controls.email.errors?.['emailused']">
                  {{ 'Email address had been used.' | translate }}
                </div>
                <div
                  *ngIf="form.controls.email.errors?.['emailformat'] || form.controls.email.errors?.['email']"
                >
                  {{ 'Email address format is incorrect.' | translate }}
                </div>

                <div *ngIf="form.controls.email.errors?.['emailNotVerified']">
                  {{ 'Email address is not verified.' | translate }}
                </div>
              </div>

              <div
                *ngIf="form.invalid"
                class="text-red-600 col-span-12 text-xs mt-1"
              >
                <div
                  *ngIf="form.controls.email.errors?.['emailandphonemissing'] && form.controls.mobilePhone.errors?.['emailandphonemissing']"
                >
                  {{ 'Please provider either phone or email.' | translate }}
                </div>
                <div *ngIf="form.errors?.['emailorphoneused']">
                  {{
                    'Phone number or email address had been used.' | translate
                  }}
                </div>
              </div>
            </div>
          </div>
          <!-- Password -->
          <div class="grid grid-cols-12 mt-4 mb-6" *ngIf="mode == 'register'">
            <label
              for="password"
              class="col-span-12 md:col-span-2 block mb-2 text-sm font-medium text-gray-900 dark:text-white pr-1 my-2"
              ><span
                class="text-base font-medium text-green-900 dark:text-white"
                >{{ 'Password' | translate }}</span
              >
              <span class="text-red-500">*</span></label
            >
            <div class="col-span-12 md:col-span-10 pr-2 relative">
              <input
                [type]="isPasswordVisible ? 'text' : 'password'"
                name="password"
                id="password"
                placeholder=""
                class="border border-gray-300 text-gray-900 text-sm rounded-3xl focus:ring-green-600 focus:border-green-600 focus:outline-green-600 block w-full p-2.5 px-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 focus:outline-0"
                required=""
                formControlName="password"
                (input)="checkPassword($event)"
                autocomplete="new-password"
              />
              <fa-icon
                class="absolute p-2.5 leading-5 top-0 right-4 text-gray-400"
                *ngIf="!isPasswordVisible"
                [icon]="faEyeSlash"
                (click)="togglePassword()"
              ></fa-icon>
              <fa-icon
                class="absolute p-2.5 leading-5 top-0 right-4 text-gray-400"
                *ngIf="isPasswordVisible"
                [icon]="faEye"
                (click)="togglePassword()"
              ></fa-icon>
            </div>
            <div class="col-span-12 md:col-span-2"></div>
            <div class="col-span-12 md:col-span-10 pr-2">
              <div
                *ngIf="
                  form.controls.password.invalid &&
                  (form.controls.password.dirty ||
                    form.controls.password.touched)
                "
                class="text-red-600 col-span-12 md:col-span-10 text-xs mt-1"
              >
                <div *ngIf="form.controls.password.errors?.['required']">
                  {{ 'Password is required.' | translate }}
                </div>
                <div *ngIf="form.controls.password.errors?.['requirement']">
                  {{ 'Password does not fulfill requirement.' | translate }}
                </div>
              </div>
              <div class="text-xs mt-2">
                <div class="text-gray-600">
                  {{ 'Password requirements:' | translate }}
                </div>
                <ul>
                  <li
                    [class]="
                      !isPasswordHasLowercase
                        ? 'text-gray-600'
                        : 'text-green-700'
                    "
                  >
                    <div class="w-4 inline-block">
                      <fa-icon
                        [icon]="faCheck"
                        *ngIf="isPasswordHasLowercase"
                      ></fa-icon>
                      <fa-icon
                        [icon]="faCircle"
                        *ngIf="!isPasswordHasLowercase"
                        size="xs"
                      ></fa-icon>
                    </div>
                    {{ 'One lowercase character' | translate }}
                  </li>
                  <li
                    [class]="
                      !isPasswordHasUppercase
                        ? 'text-gray-600'
                        : 'text-green-700'
                    "
                  >
                    <div class="w-4 inline-block">
                      <fa-icon
                        class=""
                        [icon]="faCheck"
                        *ngIf="isPasswordHasUppercase"
                      ></fa-icon>
                      <fa-icon
                        [icon]="faCircle"
                        *ngIf="!isPasswordHasUppercase"
                        size="xs"
                      ></fa-icon>
                    </div>
                    {{ 'One uppercase character' | translate }}
                  </li>
                  <li
                    [class]="
                      !isPasswordHasNumber ? 'text-gray-600' : 'text-green-700'
                    "
                  >
                    <div class="w-4 inline-block">
                      <fa-icon
                        class=""
                        [icon]="faCheck"
                        *ngIf="isPasswordHasNumber"
                      ></fa-icon>
                      <fa-icon
                        [icon]="faCircle"
                        *ngIf="!isPasswordHasNumber"
                        size="xs"
                      ></fa-icon>
                    </div>
                    {{ 'One number' | translate }}
                  </li>
                  <li
                    [class]="
                      !isPasswordLength8 ? 'text-gray-600' : 'text-green-700'
                    "
                  >
                    <div class="w-4 inline-block">
                      <fa-icon
                        class=""
                        [icon]="faCheck"
                        *ngIf="isPasswordLength8"
                      ></fa-icon>
                      <fa-icon
                        [icon]="faCircle"
                        *ngIf="!isPasswordLength8"
                        size="xs"
                      ></fa-icon>
                    </div>
                    {{ '8 characters minimum' | translate }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Repeat Password -->
          <div class="grid grid-cols-12 mt-4 mb-4" *ngIf="mode == 'register'">
            <label
              for="repeatPassword"
              class="col-span-12 md:col-span-2 block mb-2 text-sm font-medium text-gray-900 dark:text-white my-2"
              ><span
                class="text-base font-medium text-green-900 dark:text-white"
                >{{ 'Repeat Password' | translate }}</span
              >
              <span class="text-red-500">*</span></label
            >
            <div class="col-span-12 md:col-span-10 pr-2 relative">
              <input
                [type]="isRepeatPasswordVisible ? 'text' : 'password'"
                name="repeatPassword"
                id="repeatPassword"
                placeholder=""
                class="border border-gray-300 text-gray-900 text-sm rounded-3xl focus:ring-green-600 focus:border-green-600 focus:outline-green-600 block w-full p-2.5 px-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 focus:outline-0"
                required=""
                formControlName="repeatPassword"
                autocomplete="new-password"
              />
              <fa-icon
                class="absolute p-2.5 leading-5 top-0 right-4 text-gray-400"
                *ngIf="!isRepeatPasswordVisible"
                [icon]="faEyeSlash"
                (click)="toggleRepeatPassword()"
              ></fa-icon>
              <fa-icon
                class="absolute p-2.5 leading-5 top-0 right-4 text-gray-400"
                *ngIf="isRepeatPasswordVisible"
                [icon]="faEye"
                (click)="toggleRepeatPassword()"
              ></fa-icon>
            </div>
            <div class="col-span-12 md:col-span-2"></div>
            <div
              *ngIf="
                form.controls.repeatPassword.invalid &&
                form.controls.repeatPassword.touched
              "
              class="text-red-600 col-span-12 md:col-span-10 text-xs mt-1"
            >
              <div *ngIf="form.controls.repeatPassword.errors?.['required']">
                {{ 'Repeat password is required.' | translate }}
              </div>
              <div *ngIf="form.controls.repeatPassword.errors?.['match']">
                {{ 'The repeat password does not match.' | translate }}
              </div>
            </div>
          </div>

          <hr class="mb-4" />

          <!-- Company -->
          <div class="grid grid-cols-12">
            <div class="col-span-12 md:col-span-2">
              <label
                for="email"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white my-2"
                ><span
                  class="text-base font-medium text-green-900 dark:text-white"
                  >{{ 'Company' | translate }}</span
                >
                <span
                  class="text-red-500"
                  *ngIf="!form.controls.noCompanyInfo.value"
                  >*</span
                ></label
              >
            </div>
            <div class="col-span-12 md:col-span-10 grid grid-cols-12">
              <div class="col-span-12 pb-2 md:col-span-6 md:pr-2 md:pb-0 mb-2">
                <span class="p-float-label relative">
                  <input
                    pInputText
                    name="companyName"
                    id="companyName"
                    class="border border-gray-300 text-gray-900 text-sm rounded-3xl focus:ring-green-600 focus:border-green-600 focus:outline-green-600 block w-full p-2.5 px-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:bg-gray-100"
                    placeholder=""
                    formControlName="companyName"
                    [disabled]="noCompanyInfo"
                    [attr.disabled]="disableUserInfo ? '' : null"
                  />
                  <label for="companyName" class="">{{
                    'Company Name' | translate
                  }}</label>
                </span>
                <div
                  *ngIf="
                    form.controls.companyName.invalid &&
                    (form.controls.companyName.dirty ||
                      form.controls.companyName.touched)
                  "
                  class="text-red-600 col-span-10 text-xs mt-1"
                >
                  <div *ngIf="form.controls.companyName.errors?.['required']">
                    {{ 'Company name is required.' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-span-12 pb-2 md:col-span-6 md:pr-2 md:pb-0 mb-2">
                <select
                  name="companyInd"
                  formControlName="companyInd"
                  class="leading-5 border border-gray-300 rounded-3xl focus:outline-none focus:ring-green-600 focus:border-green-600 block w-full p-2.5 px-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:bg-gray-100"
                  [class]="
                    formValues.companyInd == ''
                      ? 'text-gray-500'
                      : 'text-gray-900'
                  "
                  [disabled]="noCompanyInfo"
                  [attr.disabled]="disableUserInfo ? '' : null"
                >
                  <option value="" disabled selected>
                    {{ 'Select Industry...' | translate }}
                  </option>
                  <option value="Academic Institution">
                    {{ 'Academic Institution' | translate }}
                  </option>
                  <option value="Consultant">
                    {{ 'Consultant' | translate }}
                  </option>
                  <option value="Contractor">
                    {{ 'Contractor' | translate }}
                  </option>
                  <option value="Freelance">
                    {{ 'Freelance' | translate }}
                  </option>
                  <option value="Government">
                    {{ 'Government' | translate }}
                  </option>
                  <option value="Manufacturer/Supplier/Startup">
                    {{ 'Manufacturer/Supplier/Startup' | translate }}
                  </option>
                  <option value="Professional Body">
                    {{ 'Professional Body' | translate }}
                  </option>
                  <option value="Project Client">
                    {{
                      'Project Client (Developer/Estate Officer/NGO)'
                        | translate
                    }}
                  </option>
                  <option value="Property Management Company">
                    {{ 'Property Management Company' | translate }}
                  </option>
                  <option value="Research Body">
                    {{ 'Research Body' | translate }}
                  </option>
                  <option value="Statutory Body">
                    {{ 'Statutory Body' | translate }}
                  </option>
                  <option value="Trade Association">
                    {{ 'Trade Association' | translate }}
                  </option>
                  <option value="Utility Organisation">
                    {{ 'Utility Organisation' | translate }}
                  </option>
                  <option value="Others">{{ 'Others' | translate }}</option>
                </select>
                <div
                  *ngIf="
                    form.controls.companyInd.invalid &&
                    (form.controls.companyInd.dirty ||
                      form.controls.companyInd.touched)
                  "
                  class="text-red-600 col-span-10 text-xs mt-1"
                >
                  <div *ngIf="form.controls.companyInd.errors?.['required']">
                    {{ 'Company industry is required.' | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-12">
            <div class="col-span-12 md:col-span-2"></div>
            <div class="col-span-12 md:col-span-10 grid grid-cols-12">
              <div class="col-span-12 pb-2 md:col-span-6 md:pr-2 md:pb-0">
                <span class="p-float-label relative">
                  <input
                    pInputText
                    name="jobTitle"
                    id="jobTitle"
                    class="border border-gray-300 text-gray-900 text-sm rounded-3xl focus:ring-green-600 focus:border-green-600 focus:outline-green-600 block w-full p-2.5 px-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:bg-gray-100"
                    placeholder=""
                    formControlName="jobTitle"
                    [disabled]="noCompanyInfo"
                    [attr.disabled]="disableUserInfo ? '' : null"
                  />
                  <label for="lastName" class="">{{
                    'Job Title' | translate
                  }}</label>
                </span>
                <div
                  *ngIf="
                    form.controls.jobTitle.invalid &&
                    (form.controls.jobTitle.dirty ||
                      form.controls.jobTitle.touched)
                  "
                  class="text-red-600 col-span-10 text-xs mt-1"
                >
                  <div *ngIf="form.controls.jobTitle.errors?.['required']">
                    {{ 'Job title is required.' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-span-12 pb-2 md:col-span-6 md:pr-2 md:pb-0"></div>
            </div>
          </div>
          <div class="grid grid-cols-12">
            <div class="col-span-12 md:col-span-2"></div>
            <div class="col-span-12 md:col-span-10 grid grid-cols-12 mt-2">
              <div
                class="col-span-12 pb-2 md:col-span-6 md:pr-2 md:pb-0 cursor-pointer"
                (click)="onNoCompanyInfoChange()"
              >
                <input
                  type="checkbox"
                  formControlName="noCompanyInfo"
                  name="noCompanyInfo"
                  (change)="onNoCompanyInfoChange($event)"
                  class="rounded checked:bg-green-600 checked:hover:bg-green-600 checked:active:bg-green-600 checked:focus:bg-green-600 focus:outline-none focus:ring-green-600"
                  [attr.disabled]="disableUserInfo ? '' : null"
                />
                <span class="text-sm text-gray-600 ml-2">{{
                  'Prefer not to provide now' | translate
                }}</span>
              </div>
              <div class="col-span-12 pb-2 md:col-span-6 md:pr-2 md:pb-0"></div>
            </div>
          </div>

          <hr class="my-4" />
          <div class="mt-6 flex flex-row justify-center md:justify-start">
              <button
                class="flex flex-row justify-center w-40 text-white bg-notus-primary-600 hover:bg-notus-primary-700 focus:outline-none focus:ring-notus-primary-300 font-medium rounded-3xl text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 items-center"
                *ngIf="!isLoading && mode == 'register'"
                (click)="onRegisterStep2Back()"
              >
                {{ 'Back' | translate }}
              </button>
            <div class="flex-grow"></div>
            <button
              type="submit"
              class="flex flex-row justify-center w-40 text-white bg-notus-primary-600 hover:bg-notus-primary-700 focus:outline-none focus:ring-notus-primary-300 font-medium rounded-3xl text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 items-center"
              *ngIf="!isLoading && !disableUserInfo"
              (click)="
                mode == 'register' ? onRegisterWithEmail() : onUpdateProfile()
              "
            >
              <ng-container *ngIf="mode == 'register'">
                {{ 'Next' | translate }}
              </ng-container>
              <ng-container *ngIf="mode == 'profile'">
                {{ 'Save' | translate }}
              </ng-container>
            </button>
            <button
              type="submit"
              disabled
              class="flex flex-row justify-center w-40 text-white bg-gray-300 focus:outline-none focus:ring-notus-primary-300 font-medium rounded-3xl text-sm px-5 py-2.5 text-center dark:bg-white"
              *ngIf="isLoading"
            >
              <flowbite-loading size="1.25rem"></flowbite-loading>
            </button>
          </div>
        </div>
      </div>
      <div
        *ngIf="isTandC"
        class="switch-page w-full max-w-3xl md:mt-0 xl:p-0 mr-auto"
        [class]="
          [currentStep == 3 ? 'active' : currentStep > 3 ? 'past' : 'future',

          (mode == 'register' ? '' : 'hidden')
          ]
        "
      >
        <div class="sm:px-4" [class]="pv ? '' : 'p-0 sm:p-0 sm:px-0'">
          <div class="col-span-12 md:col-span-10 grid grid-cols-12">
            <div
              class="col-span-12 md:col-span-6 md:pr-2 md:pb-0 flex flex-row space-x-2"
            >
              <!-- <fa-icon class="text-green-600 cursor-pointer" [icon]="faBack" (click)="onRegisterStep3Back()"></fa-icon> -->
              <label
                for="email"
                class="block mb-2 font-medium text-gray-900 dark:text-white"
                ><span
                  class="text-xl font-medium text-green-900 dark:text-white"
                  >{{ 'Terms and Conditions' | translate }}</span
                ></label
              >
            </div>
          </div>
          <div class="text-gray-600">
            <div
              class="h-[calc(90vh-20rem)] overflow-y-scroll border p-2"
              (scroll)="onTandc2Scroll($event)"
            >
              <ng-container *ngIf="translate.currentLang == 'en'">
                PLEASE READ THE FOLLOWING TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS WEBSITE. BY USING THIS WEBSITE YOU AGREE TO ABIDE BY THE TERMS AND CONDITIONS SET OUT BELOW. <br />
                 <br />
                <b><u>DISCLAIMER</u></b><br />
                The information contained in this website is compiled by the Construction Industry Council (CIC) for general information only. Whilst CIC endeavours to ensure the accuracy of this general information, no statement, representation, warranty or guarantee, express or implied, is given as to its accuracy or appropriateness for use in any particular circumstances.  <br />
                CIC website and material relating to information, products and services (or to third party information, products and services), is provided 'as is', without any representation or endorsement made and without warranty of any kind whether express or implied, including, but not limited to, the implied warranties of satisfactory quality, fitness for a particular purpose, non-infringement, compatibility, security, completeness and accuracy.  <br />
                In no event will CIC be liable for any expense, loss or damage including, without limitation, indirect or consequential loss or damage, or any expense, loss or damage whatsoever arising from use, or loss of use, of data, or loss of profits, arising out of or in connection with the use of this website, or reliance on its content.  <br />
                No data transmission over the internet can be guaranteed as totally secure. Whilst CIC strives to protect such information, CIC does not warrant and cannot ensure the security of any information which you transmit to us.  <br />
                CIC website is not a substitute for independent professional advice and users should obtain any appropriate professional advice relevant to their particular circumstances.  <br />
                This website can also contain information contributed by others over whom, and in respect of which, CIC may have no influence. Users may link from this website to sites provided by others. CIC expressly states that it has not approved or endorsed the information provided by others on this website or any other sites linked to this website and CIC accepts no responsibility or liability (howsoever caused) for such information.   <br />
                 <br />
                <b><u>MEMBER LOGIN</u></b> <br />
                Please note that submission of information over the internet may be subject to interruption, transmission blackout, delayed transmission due to internet traffic, or incorrect data transmission due to the public nature of the Internet. The Council cannot assume responsibility for malfunctions in communications facilities not under our control that may affect the accuracy or timeliness of messages you send. <br />
                 <br />
                Last Updated Date: 25th September, 2025

              </ng-container>
              <ng-container *ngIf="translate.currentLang == 'zh-Hant'">
                在使用本網站前，請仔細閱讀以下的條款及條件。如閣下使用本網站，即表示閣下同意遵守下列條款及條件。<br />
                <br />
                <b><u>免責聲明</u></b><br />
                本網站載列的資料由建造業議會（議會）編製，只供一般參考。議會雖已盡力確保該等資料準確，但對於該等資料在任何特定情況下使用時的準確性或恰當性，並沒有作出任何明示或隱含的陳述、申述、保證或擔保。<br />
                本網站及有關資訊、產品和服務的材料（或有關第三者的資訊、產品和服務的材料），均以當前展示的形式提供，概無作出任何陳述或認可證明，亦概無作出任何類型、不論明示或隱含的擔保，包括但不限於提供滿意的質素、切合特定的目的、非侵權、兼容性、保安、完整性及準確性的隱含保證。 <br />
                不論任何情況下，議會將不會就任何支出、損失或損毀，包括但不限於間接或相應而生的損失或損毀，或任何由使用數據或不使用數據而招致的任何支出、損失或損毀，或由使用本網站而導致的或與使用本網站有關的利潤損失，或依賴有關內容而負上任何法律責任。 <br />
                透過互聯網作出的數據傳輸並不能擔保絕對保密。縱使議會致力保護有關資料，惟議會並不擔保，亦不能保證閣下傳送予議會的任何資料的保密性。 <br />
                本網站並非獨立專業意見的代替品，各使用者應該在適用其特定情況下獲取任何適當的專業意見。 <br />
                本網站亦可能載有由其他人士或機構所提供的資料，而議會對該等人士或機構以及對該等資料並無影響力。使用者可從本網站連結至由其他人士或機構所提供的網站。議會現明文述明，議會並沒有核准或認可由其他人士或機構在本網站或與本網站連結的其他網站上所提供的資料，對於該等資料亦不承擔任何責任或法律責任（不論該等責任是如何導致的）。<br />
                <br />
                <b><u>成員登入</u></b><br />
                注意︰基於互聯網的運作性質，經互聯網提交的資料可能受到干擾、傳送中斷、傳送延誤或傳送錯誤資料。在建造業議會控制範圍以外的通訊設施發生任何故障，影響閣下傳送信息的準確性或時效，建造業議會概不負責。<br />
                <br />
                最後更新日期: 2025年9月25日
              </ng-container>
              <ng-container *ngIf="translate.currentLang == 'zh-Hans'">
                在使用本网站前，请仔细阅读以下的条款及条件。如阁下使用本网站，即表示阁下同意遵守下列条款及条件。<br />
                <br />
                <b><u>免责声明</u></b><br />
                本网站载列的资料由建造业议会（议会）编制，只供一般参考。议会虽已尽力确保该等资料准确，但对于该等资料在任何特定情况下使用时的准确性或恰当性，并没有作出任何明示或隐含的陈述、申述、保证或担保。 <br />
                本网站及有关资讯、产品和服务的材料（或有关第三者的资讯、产品和服务的材料），均以当前展示的形式提供，概无作出任何陈述或认可证明，亦概无作出任何类型、不论明示或隐含的担保，包括但不限于提供满意的质素、切合特定的目的、非侵权、兼容性、保安、完整性及准确性的隐含保证。 <br />
                不论任何情况下，议会将不会就任何支出、损失或损毁，包括但不限于间接或相应而生的损失或损毁，或任何由使用数据或不使用数据而招致的任何支出、损失或损毁，或由使用本网站而导致的或与使用本网站有关的利润损失，或依赖有关内容而负上任何法律责任。 <br />
                透过互联网作出的数据传输并不能担保绝对保密。纵使议会致力保护有关资料，惟议会并不担保，亦不能保证阁下传送予议会的任何资料的保密性。 <br />
                本网站并非独立专业意见的代替品，各使用者应该在适用其特定情况下获取任何适当的专业意见。 <br />
                本网站亦可能载有由其他人士或机构所提供的资料，而议会对该等人士或机构以及对该等资料并无影响力。使用者可从本网站连结至由其他人士或机构所提供的网站。议会现明文述明，议会并没有核准或认可由其他人士或机构在本网站或与本网站连结的其他网站上所提供的资料，对于该等资料亦不承担任何责任或法律责任（不论该等责任是如何导致的）。<br />
                <br />
                <b><u>成员登入</u></b><br />
                注意︰基于互联网的运作性质，经互联网提交的资料可能受到干扰、传送中断、传送延误或传送错误资料。在建造业议会控制范围以外的通讯设施发生任何故障，影响阁下传送信息的准确性或时效，建造业议会概不负责。<br />
                <br />
                最后更新日期: 2025年9月25日
              </ng-container>
            </div>
            <div
              *ngIf="isTandc2Error && !isTandc2Read"
              class="text-red-600 col-span-10 mt-2"
            >
              {{
                'Please read the Notice to Applicants to the end.' | translate
              }}
            </div>
            <!-- <div class="mt-2">
            <input type="checkbox" name="tandc2" (change)="onTandc2Change($event)" class="rounded checked:bg-green-600 checked:hover:bg-green-600 checked:active:bg-green-600 checked:focus:bg-green-600 focus:outline-none focus:ring-green-600" /><span class="text-red-500 ml-1">*</span>
            <span class="text-gray-600 ml-2">{{ 'I have read and understand the Notice to Applicants' | translate }}</span>
          </div>
          <div
          *ngIf="!isTandc2 && isSubmitted"
          class="text-red-600 col-span-10 mt-2"
          >
            {{ 'Please agree with the Notice to Applicants.' | translate }}
          </div> -->
            <div class="mt-6 flex flex-row justify-center md:justify-start">
              <button
                class="flex flex-row justify-center w-40 text-white bg-notus-primary-600 hover:bg-notus-primary-700 focus:outline-none focus:ring-notus-primary-300 font-medium rounded-3xl text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 items-center"
                *ngIf="!isLoading"
                (click)="onRegisterStep3Back()"
              >
                {{ 'Back' | translate }}
              </button>
              <div class="flex-grow"></div>
              <button
                class="flex flex-row justify-center w-40 text-white bg-notus-primary-600 hover:bg-notus-primary-700 focus:outline-none focus:ring-notus-primary-300 font-medium rounded-3xl text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 items-center"
                *ngIf="!isLoading && !disableUserInfo"
                (click)="onRegisterStep3Confirm()"
              >
                {{ 'Agree and Register' | translate }}
              </button>
              <button
                type="submit"
                disabled
                class="flex flex-row justify-center w-40 text-white bg-gray-300 focus:outline-none focus:ring-notus-primary-300 font-medium rounded-3xl text-sm px-5 py-2.5 text-center dark:bg-white"
                *ngIf="isLoading"
              >
                <flowbite-loading size="1.25rem"></flowbite-loading>
              </button>
            </div>
          </div>
        </div>

        <div class="flex items-center justify-between">
          <!-- <div class="flex items-start">
              <p class="text-sm font-light text-gray-500 dark:text-gray-400">
                {{ 'Already registered?' | translate }}
                <a
                  (click)="onLogin($event)"
                  class="font-medium text-notus-primary-600 hover:underline dark:text-primary-500"
                  >{{ 'Login' | translate }}</a
                >
              </p>
            </div> -->
          <!-- <a
              href="#"
              class="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500"
              >{{ 'Forgot password?' | translate }}</a
            > -->
        </div>
      </div>
    </div>
  </div>
</div>

<ciciam-sms-verify-popup #smsPopup [smsMode]="smsMode"></ciciam-sms-verify-popup>
<ciciam-email-verify-popup #emailPopup [emailMode]="emailMode"></ciciam-email-verify-popup>
